<div [ngClass]="editorClass">
  <editor apiKey="" [init]="tinyMCEConfiguration" [(ngModel)]="message.text" (onFocusIn)="onFocus($event)" (onFocusOut)="onBlur()"></editor>
</div>
